import $ from 'jquery'
import Splide from '@splidejs/splide'

$('.js-products-block-slider').each(function () {
    var $this = $(this);
    var splideInstance = new Splide($this[0], {
        pagination: false,
        arrows: false,
        perPage: 3,
        destroy: true,
        breakpoints: {
            991: {
                destroy: false,
                perPage: 2,
                padding: { right: '5%' },
            },
            719: {
                perPage: 1,
                padding: { right: '5%' },
            }
        }
    });

    splideInstance.mount();
});